
window.Tawk_API = window.Tawk_API || {};
function handleNewsletterSignup(data) {
    try {
        // If label with "Newsletter" is present in the data, we've a positive newsletter sign up (i know, i know... fuzzy as hell, but no other option).
        var newsLetterSignUp = false;
        for (var i = 0; i < data.length; i++) {
            if (data[i].label === "Newsletter") {
                newsLetterSignUp = true;
                break;
            }
        }

        if (newsLetterSignUp) {
            const endpoint = '/ajax/request-newsletter';
            const formDataObj = {};

            // Iterate through the details array and populate the formDataObj
            for (var j = 0; j < data.length; j++) {
                formDataObj[data[j].label.toLowerCase()] = data[j].answer;
            }

            // insert a source property
            formDataObj['source'] = 'tawk';
            formDataObj['list-name'] = 'chatBoxSignUp';

            // Convert the form data object to a URL-encoded string
            const urlEncodedData = new URLSearchParams(formDataObj).toString();

            // Create a URLSearchParams object with a "data" field containing the encoded form data
            const formBody = new URLSearchParams();
            formBody.append('data', urlEncodedData);

            // Fetch POST request to endpoint (we're not really bothered about the response, but commented out for eas of testing)
            fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: formBody.toString()
            });
        }
    } catch (error) {
        //console.error(error);
    }
};


window.Tawk_API.onPrechatSubmit = function (data) {
    handleNewsletterSignup(data);
};

window.Tawk_API.onOfflineSubmit = function (data) {
    handleNewsletterSignup(data.questions);
};

$(document).on('click', '.open-chat', function (e) {
    window.Tawk_API.toggle();
})
